


<div class="container h-100 flex-column  d-flex align-items-center justify-content-center">
  <img class="mb-4 d-block" src="./assets/images/logo_Luiss.png" height="40">
  <div class="d-flex flex-column " *ngIf="!loginPage">
    <!-- <button class="btn btn-primary w-100 mb-3" (click)="loginPage='auth'">
        <span>Accedi su Lezioni</span>
    </button>
    <button class="btn btn-primary w-100 mb-3" (click)="loginPage='auth'">
        <span>Accedi su Tutorato</span>
    </button>
    <button class="btn btn-primary w-100 mb-3" (click)="loginPage='adfs'">
        <span>Accedi su Rilevazione presenze</span>
    </button> -->
    <button class="btn btn-primary w-100 mb-3" (click)="loginPage='adfs'">
        <span>Gestione Notifiche</span>
    </button>
  </div>
    <div class="row">
        <div class="col-12">
            <div *ngIf="loginPage && req && loginPage!=='adfs'" class="border shadow-lg p-5 bg-white rounded">
                <form *ngIf="formGroup" [formGroup]="formGroup">
                    <div class="form-group">
                      <input type="text" class="form-control" formControlName="username" [(ngModel)]="req.username" aria-describedby="emailHelp" placeholder="Inserisci username">
                    </div>
                    <div class="form-group">
                      <input type="password" class="form-control" formControlName="password" [(ngModel)]="req.password" placeholder="Inserisci password">
                    </div>
                    <button class="btn btn-primary w-100" [disabled]="waitLogin || !formGroup.valid" (click)="login()">
                        <span>Accedi <i *ngIf="waitLogin" class="fas fa-circle-notch fa-spin ml-2"></i></span>
                    </button>
                  </form>
            </div>
            <div *ngIf="loginPage==='adfs'" class="border shadow-lg p-5 bg-white rounded">
                  <button class="btn btn-primary w-100" (click)="loginAdfs()">
                      <span>Accedi su Luiss</span>
                  </button>
            </div>
            <p *ngIf="loginPage" class="mb-0 text-primary cursor-pointer mt-2" (click)="loginPage=''">Torna indietro</p>
        </div>
    </div>
</div>